module.exports = __webpack_public_path__ + "img/website-service-02.fe00e88b.png";